import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { entrar, getToken } from "../services/auth";
import { useParameter } from "../hooks/useParameter";


export const LoginContext = createContext([])

export const useLoginContext= () => useContext(LoginContext);

export const LoginProvider = ({children}) => {
    const [typeFreight, setTypeFreight] = useState({});
    const [reloadSidebar, setReloadSidebar] = useState(false);
    const {getDfe, getDelivery} = useParameter();
    
    const setSessionExpiration = (hours = 10) => {
        const expirationTime = Date.now() + hours * 60 * 60 * 1000; // 10 horas em ms
        entrar("sessionExpiration", expirationTime.toString());
    }

    const validationImportNFCE = async () => {
        const {data, success} = await getDfe()
        if(success && data?.emitcnpj?.length > 0) entrar('IMPORTDELIVERYORTABLE', true);
        else entrar('IMPORTDELIVERYORTABLE', false);
    }

    const verifyTypeFreightLocalStorage = () => {
        const result = JSON.parse(getToken('TYPE_FREIGHT'))
        return result === null || result === undefined ? {success:false, data:result} : {success:true, data:result}
    }

    const verifyTipeFreight = async () => {
        const {data: dataLocal, success: successLocal} = verifyTypeFreightLocalStorage()
        if (successLocal) return setTypeFreight({...dataLocal})

        const {data, success} = await getDelivery()
        if(success)saveLocalStorageTypeFreight(data)
    }
    
    const saveLocalStorageTypeFreight = (data) => {
        if(data?.site_frete_raio === 'S'){ 
            setTypeFreight({ray: true, locality: false, value_freight: false})
            return entrar('TYPE_FREIGHT', JSON.stringify({ray: true, locality: false, value_freight: false}));
        }
        else if (data?.site_frete > 0) {
            setTypeFreight({ray: false, locality: false, value_freight: true})
            return entrar('TYPE_FREIGHT', JSON.stringify({ray: false, locality: false, value_freight: true}));
        }
        else {
            setTypeFreight({ray: false, locality: true, value_freight: false})
            return entrar('TYPE_FREIGHT', JSON.stringify({ray: false, locality: true, value_freight: false}));
        }
    }

    useEffect(() => {
        verifyTipeFreight()
    }, [])

    const contextValue = useMemo(() => ({
        setSessionExpiration,
        validationImportNFCE,
        typeFreight,
        setTypeFreight,
        verifyTipeFreight,
        reloadSidebar, 
        setReloadSidebar
    }), [typeFreight, setTypeFreight, reloadSidebar, setReloadSidebar]);


    return (
        <LoginContext.Provider value={contextValue}>
            {children}
        </LoginContext.Provider>
    )
}